module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M10 32h12c1.106 0 2-.894 2-2 0-1.106-.894-2-2-2h-4v-4h12c1.106 0 2-.894 2-2V2c0-1.106-.894-2-2-2H2C.894 0 0 .894 0 2v20c0 1.106.894 2 2 2h12v4h-4c-1.106 0-2 .894-2 2 0 1.106.894 2 2 2zm18-12H4V4h24v16z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/imac-1.js
// module id = 1179
// module chunks = 14